import { ExternalId } from './ExternalId'

import camelCaseKeys from 'camelcase-keys'

export class Account {
  constructor (params = {}) {
    const {
      id,
      sequence,
      externalIds,
      profile,
      profileId,
      active,
      facility,
      facilityId,
      attributes,
      pricingGroupId
    } = camelCaseKeys(params, { deep: true })
    this.id = id || null
    this.sequence = sequence || null
    this.externalIds = externalIds ? externalIds.map((e) => new ExternalId(e)) : []
    this.profileId = profileId || null
    this.profile = profile || this.profileId
    this.active = active || false
    this.facilityId = facilityId || null
    this.facility = facility || this.facilityId
    this.attributes = attributes || null
    this.pricingGroupId = pricingGroupId || null
  }
  serialize (editedFields) {
    var item = JSON.parse(JSON.stringify(this))
    Object.keys(editedFields).forEach(key => {
      item[key] = editedFields[key]
    })
    return {
      id: item.id,
      profileId: item.profileId,
      attributes: item.attributes,
      active: item.active,
      facilityId: item.facilityId
    }
  }
}
